import * as React from "react"
import { async } from "widgets-for-react"
import { BlockRenderer } from "../../../components/block_renderer"
import { Jumbo } from "../../../components/jumbo"
import { OvaticLocation } from "../LocationState"
import { loadLocation, loadMeans } from "./LocationOptionForm/LocationOptionFormApi"
import { LocationOptionForm } from "./LocationOptionForm/LocationOptionFormLayout"
import { LocationPageProps, LocationPageState, Means } from "./LocationPageState"

export class LocationPage extends React.Component<LocationPageProps, LocationPageState> {
  constructor(props) {
    super(props)

    this.state = {
      location: loadLocation(props.locationId),
      means: loadMeans(props.locationId)
    }
  }

  componentDidMount() {
    document.title = this.props.pageTitle
  }

  render() {
    const p = this.props

    return (<>
      {async<Means[]>()(this.state.means).run(
        meansUpdater => this.setState(oldState => ({ ...oldState, means: meansUpdater(oldState.means) }))
      )}
      {async<OvaticLocation>()(this.state.location).run(
        locationUpdater => this.setState(oldState => ({ ...oldState, location: locationUpdater(oldState.location) }))
      )}
      <div className='location-page'>
        <Jumbo
          title={p.headerTitle}
          contents={p.description}
          imageUrlSmall={p.jumboSize == 'small' && p.phImageUrlSmall ? p.phImageUrlSmall : undefined}
          imageUrl={p.phImageUrl}
          imageUrlLarge={p.phImageUrlLarge}
          imageAlt={p.imageAlt}
          buttonUrl={p.buttonUrl}
          buttonTitle={p.buttonTitle}
          size={p.jumboSize}
        />

        <LocationOptionForm locationId={p.locationId} location={this.state.location} means={this.state.means} />

        <BlockRenderer blocks={p.blocks} />
      </div>
    </>
    )
  }
}

{/* TH: Added to styleguide! */ }
